import { useState } from 'react';

import { Button, Close, Confirm } from '@core/ui';

import { Trans, useTranslation } from 'react-i18next';
import { Chapter } from '@core/types';

interface Props {
    onDeleteChapterClick: (chapter: Chapter) => void;
    chapter: Chapter;
}

export const DeleteChapterButton = ({ onDeleteChapterClick, chapter }: Props) => {
    const [deleteChapterConfirmationShown, setDeleteChapterConfirmationShown] = useState(false);

    const showDeleteChapterConfirmation = () => {
        if (!chapter.chapterTitle) {
            onDeleteChapterClick(chapter);
            return;
        }

        setDeleteChapterConfirmationShown(true);
    };

    const { t } = useTranslation();

    return (
        <td className="px-0 pt-1 pb-0">
            <Button type="button" iconbtn data-testid="chapter-delete-button" onClick={showDeleteChapterConfirmation}>
                <Close classNames="size-6 stroke-warning" />
                <span className="sr-only">
                    <Trans i18nKey="Content.Chapters.Button.DeleteChapter" values={{ chapter: chapter.chapterTitle }} />
                </span>
            </Button>
            <Confirm
                title={t('Content.Chapters.ConfirmDelete.Title')}
                confirmTestId="chapter-delete-confirm"
                closeTestId="chapter-delete-cancel"
                open={deleteChapterConfirmationShown}
                onClose={() => setDeleteChapterConfirmationShown(false)}
                onConfirm={() => {
                    onDeleteChapterClick(chapter);
                }}
                key={`deletePopup-${chapter.chapterId}`}
            >
                <Trans i18nKey="Content.Chapters.ConfirmDelete.Msg" values={{ chapter: chapter.chapterTitle }} />
            </Confirm>
        </td>
    );
};
